import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {BasketPageService_ApplyCouponLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {ApplyCouponResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useUpdateBasketSectionsCallback} from './useUpdateBasketSections';

export const useApplyWebCouponToExistingBasket = () => {
  const session = useFullSession();
  const targetGroupIdentifier = useTargetGroupIdentifier();

  const updatePageBulkSections = useUpdateBasketSectionsCallback();
  const reductionsState = useReductionsStateRequestParameter();

  const applyCouponCallback = useGrpcRequestMutation(
    BasketPageService_ApplyCouponLazy,
    {
      disabled: !session,
      onSuccess: (data: ApplyCouponResponse) => {
        updatePageBulkSections(data.sections);
      },
    },
  );

  return useCallback(
    async (couponPromotionId: string) => {
      return applyCouponCallback
        .mutateAsync({
          session: session!,
          targetGroup: targetGroupIdentifier,
          couponPromotionId,
          itemKey: null,
          reductionsState,
        })
        .then(data => {
          return {
            basketToken: data.sections.basketToken,
            error: data.type?.error,
            totalPrice: data.sections.totalPriceSection,
          };
        });
    },
    [applyCouponCallback, session, targetGroupIdentifier, reductionsState],
  );
};
